<template>
	<div>
		<nav class="navbar is-fixed-bottom is-dark is-hidden-desktop quinielazoBottomBar" :class="{'is-hidden-mobile is-hidden-tablet' : !loggedIn}">
			<div class="container">
				<div class="level is-mobile">
					<div class="level-item has-text-centered" :class="{ 'is-active' : this.$route.path == '/jugar'}">
						<router-link to="/jugar">
							<div class="nav-item">
								<font-awesome-icon icon="home" />
							</div>
						</router-link>
					</div>
					<div class="level-item has-text-centered" :class="{'is-active' : this.$route.path == '/mis-quinielas'}">
						<router-link to="/mis-quinielas">
							<div class="nav-item">
								<font-awesome-icon icon="check-square" />
							</div>
						</router-link>
					</div>
					<div class="level-item has-text-centered" :class="{'is-active' : this.$route.path == '/quinielas-publicas'}">
						<router-link to="/quinielas-publicas">
							<div class="nav-item">
								<font-awesome-icon icon="globe-americas" />
							</div>
						</router-link>
					</div>
					<div class="level-item has-text-centered" :class="{'is-active' : this.$route.path == '/actividad'}">
						<router-link to="/actividad">
							<div class="nav-item">
								<font-awesome-icon icon="rss" />
							</div>
						</router-link>
					</div>
					<div class="level-item has-text-centered" :class="{'is-active' : this.$route.path == '/buscar'}">
						<router-link to="/buscar">
							<div class="nav-item">
								<font-awesome-icon icon="search" />
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</nav>

		<footer class="footer" :class="{'is-hidden-mobile is-hidden-tablet-only' : loggedIn}">
			<div class="container foot-container">
				<nav class="navbar">
					<div class="navbar-menu is-active">
						<div class="navbar-start">
							<router-link class="navbar-item" to="/estadistica">Estadistica</router-link>
							<router-link class="navbar-item" to="/reglas">Reglamento</router-link>
							<router-link class="navbar-item" v-if="loggedIn" to="/configuracion">Configuración</router-link>
							<router-link class="navbar-item" to="/ayuda">Ayuda / FAQ</router-link>
						</div>

						<div class="navbar-end">
							<a href="https://www.facebook.com/quinielazo" class="navbar-item"><font-awesome-icon :icon="['fab','facebook-square']" size="2x" /></a>
							<a href="http://twitter.com/quinielazo" class="navbar-item"><font-awesome-icon :icon="['fab','twitter-square']" size="2x" /></a>
						</div>
					</div>
				</nav>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  	name: 'Footer',
	data() {
		return {

		};
	},
	created(){

	},
	computed: mapGetters(['loggedIn'])
};
</script>

<style lang="css" scoped>
footer{
	background-color: #C4B3AC !important;
    border-top: 1px solid #DFC9BB;
    padding: 2rem 1.5rem 4rem;
    /*text-shadow: white 0px 1px 0px;*/
}
footer.navbar, .navbar-menu{
	background-color: #C4B3AC !important;
	box-shadow:none !important;
}

@media screen and (min-width: 600px){
	.navbar-item, .navbar-link {
	    align-items: center !important;
	    display: inline-block !important;
	}
	.navbar-start,.navbar-end{
		display: flex !important;
	}
	.navbar-start{
		margin-right: auto !important;
		justify-content: flex-start;
	}
	.navbar-end{
		margin-left: auto !important;
		justify-content: flex-end;
	}
	.navbar-menu{
		display: flex !important;
	}
}

.quinielazoBottomBar{

}
.quinielazoBottomBar>.container{
	display: grid;
}
.quinielazoBottomBar a{
	width: 100%;
	color: #fff;
}
.quinielazoBottomBar .nav-item{
	padding: .5rem 0.7rem;
}
.quinielazoBottomBar .is-active{
	background-color: #292926;
}
.quinielazoBottomBar .level{
	align-items: stretch;
}
.quinielazoBottomBar .level .level-item{
	margin-bottom: 0;
}
.foot-container{
	z-index: 25;
}
</style>
